import restCrudActions from '../../../np-crud/store/restCrudActions'
import { getAxiosInstance } from '../../../np-rest/rest';
import { snackActions } from '../../../sc-utilities/SnackBar';

// Create CRUD action creator
const crudActions = restCrudActions({
    endpointBasePath: 'statistics',
    pluginName: 'STATISTIC',
    entityName: 'STATISTIC',
    fetchSuccessMessage: '',
    loadSuccessMessage: '',

});

// Fetch statistic action creators
export const fetchStatisticInit = () => {
    return crudActions.fetchInit();
};
export const fetchStatisticStart = () => {
    return crudActions.fetchStart();
};
export const fetchStatisticSuccess = (count, list) => {
    return crudActions.fetchSuccess(count, list);
};
export const fetchStatisticFail = () => {
    return crudActions.fetchFail();
};
export const fetchStatistic = filter => {
    return async dispatch => {
        await crudActions.fetch(dispatch, filter);
    };
};

export const fetchStatisticDataCount = filterData => {
    const rest = getAxiosInstance();

    return async dispatch => {
        dispatch(fetchStatisticInit());
        try {
            let countRes = await rest.post("/statistics/count", filterData);
            if (countRes.data && countRes.data.succeeded) {
                if (!countRes.data.result.data) {
                    dispatch(fetchStatisticSuccess(0, []));
                }
                return countRes.data.result.data
            }
            dispatch(fetchStatisticFail());
            snackActions.snackBar({
                message: `${countRes && countRes.data ? countRes.data.message : "Cannot fetch statistic."}`,
                options: {
                    variant: 'warning'
                }
            });
            return 0;
        } catch (error) {
            dispatch(fetchStatisticFail());
            snackActions.snackBar({
                message: `${error.message || "Cannot fetch statistic."}`,
                options: {
                    variant: 'error'
                }
            });
            return 0;
        }
    }
}


export const fetchStatisticData = filterData => {
    const rest = getAxiosInstance();

    return async dispatch => {
        dispatch(fetchStatisticInit());
        try {
            let listRes = await rest.post("/statistics/list", filterData);
            if (listRes.data && listRes.data.succeeded) {
                dispatch(fetchStatisticSuccess(filterData.count, listRes.data.result.data));
                return listRes.data.result.data
            }
            dispatch(fetchStatisticFail());
            return []

        } catch (error) {
            dispatch(fetchStatisticFail());
            return []

        }
    }
}



export const setColumnsDraggedData = (data) => {
    return ({
        type: 'HANDLE_DRAGGED_SET',
        columns: data
    });
}
export const setLocationData = (data) => {
    return ({
        type: 'HANDLE_SET_LOCATION',
        location: data
    });
}

export const fetchErasureMethod = (params) => {
    const rest = getAxiosInstance();
    return async dispatch => {
        try {
            let res = await rest.post('/customer-erasure-method/list', { listAll: true, formatForWEBUI: true, ...params });
            if (res.data && res.data.succeeded) {
                return res.data.result.data;
            }
            else {
                snackActions.snackBar({
                    message: `${res && res.data ? res.data.message : res && res.message ? res.message : "Cannot fetch securaze standards."}`,
                    options: {
                        variant: 'warning'
                    }
                });
                return [];
            }
        } catch (error) {
            return [];
        }
    };
}

export const fetchCustomers = () => {
    const rest = getAxiosInstance();
    return async dispatch => {
        try {
            let res = await rest.post('/customers/list', { listAll: true });
            if (res.data && res.data.succeeded) {
                const customers = [];
                for (var customer of res.data.result.data) {
                    customers.push({ value: customer.CustomerID, label: `${customer.Name}` });
                }
                return customers;
            }
            else {
                snackActions.snackBar({
                    message: `${res.data ? res.data.message : res.message}`,
                    options: {
                        variant: 'error'
                    }
                });
                return [];

            }
        } catch (error) {
            return [];
        }
    };
}

export const fetchCustomer = (data) => {
    const rest = getAxiosInstance();
    return async dispatch => {
        try {
            let res = await rest.post('/customers/load', data);
            if (res.data && res.data.succeeded) {               
                const customer = res.data.result.data;
                
                return { value: customer.CustomerID, label: customer.Name };
            }
            else {
                snackActions.snackBar({
                    message: `${res.data ? res.data.message : res.message}`,
                    options: {
                        variant: 'error'
                    }
                });
                return [];

            }
        } catch (error) {
            return [];
        }
    };
}
